import { DxiColumnComponent } from 'devextreme-angular/ui/nested';
import { Directive, Input } from '@angular/core';
import { FrameworkService } from '@m4u-angular/core/framework/framework.service';
import { formatNumber } from 'devextreme/localization';

@Directive({
    selector: '[formatPriceWithCurrency]'
})
export class FormatPriceWithCurrencyDirective {

    @Input() dataField: string;
    @Input() isShowZero = false;
    @Input('formatPriceWithCurrency') set currencyField(value: string) {
        this.c.calculateCellValue = (data) => {
            let number = data[this.dataField];
            const currency = data[value];

            if (number === null || number === undefined) number = 0;
            if (!this.isShowZero && number === 0) { return null; }

            let result = formatNumber(number, this.framework.CompanyInfo.NumberSum);

            if (currency) { result = `${result} ${currency}`; }

            return result;
        };
    }

    constructor(private c: DxiColumnComponent, private framework: FrameworkService) { }
}
